import { TemplateRef } from '@angular/core';

import { Subject } from 'rxjs';

import { DialogResult } from '../models/dialog.result';

export abstract class CustomDialogWithActionsComponent {
  onConfirmClicked = new Subject<void>();
  onTertiaryButtonClicked = new Subject<void>();
  onAdditionalButtonClicked = new Subject<void>();
  onConfirmEnabledChange = new Subject<boolean>();
  onCancelEnabledChange = new Subject<boolean>();
  onTertiaryButtonVisibilityChange = new Subject<boolean>();
  onAdditionalButtonVisibilityChange = new Subject<boolean>();
  onTertiaryButtonEnabledChange = new Subject<boolean>();
  onAdditionalButtonEnabledChange = new Subject<boolean>();
  onAdditionalActionsTemplateChange = new Subject<TemplateRef<any>>();
  onConfirmInProgress = new Subject<boolean>();
  onTertiaryButtonInProgress = new Subject<boolean>();
  onAdditionalButtonInProgress = new Subject<boolean>();
  onCloseDialog = new Subject<any>();
  dialogResult = new Subject<DialogResult>();
  data: any;
}
